import { baseApi } from '@/services/api';
import { Booking, Ticket, PaymentIntent } from './bookingsTypes';
import { EventsResponse, GetEventsParams } from '../events/eventsTypes';

export const bookingsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Bookings
    // getBookings: builder.query<EventsResponse, GetEventsParams | void>({
    //   query: (params) => ({
    //     url: `/bookings?${params}`,
    //     method: 'GET',
        
    //   }),
    //   providesTags: (result) =>
    //     result?.data
    //       ? [
    //           ...result.data.map(({ event_id }) => ({
    //             type: 'Events' as const,
    //             id: event_id,
    //           })),
    //           { type: 'Events', id: 'LIST' },
    //         ]
    //       : [{ type: 'Events', id: 'LIST' }],
    // }),
    getBookings: builder.query<EventsResponse, GetEventsParams | void>({
      query: (params = {}) => ({
        url: `/bookings?${params}`,
        method: 'GET',
      
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ event_id }) => ({
                type: 'Events' as const,
                id: event_id,
              })),
              { type: 'Events', id: 'LIST' },
            ]
          : [{ type: 'Events', id: 'LIST' }],
    }),
    
    getBooking: builder.query<Booking, string>({
      query: (id) => ({
        url: `/bookings/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Bookings', id }],
    }),
    
    createBooking: builder.mutation<Booking, Partial<Booking>>({
      query: (booking) => ({
        url: '/bookings',
        method: 'POST',
        body: { data: booking },
      }),
      invalidatesTags: ['Bookings', 'Tickets'],
    }),
    
    updateBooking: builder.mutation<Booking, { id: string; data: Partial<Booking> }>({
      query: ({ id, data }) => ({
        url: `/bookings/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Bookings', id }, 'Bookings'],
    }),
    
    cancelBooking: builder.mutation<void, string>({
      query: (id) => ({
        url: `/bookings/${id}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['Bookings', 'Tickets'],
    }),
    
    checkInBooking: builder.mutation<void, string>({
      query: (id) => ({
        url: `/bookings/${id}/check-in`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Bookings', id }],
    }),
    
    // Tickets
    getEventTickets: builder.query<Ticket[], string>({
      query: (eventId) => ({
        url: `/events/${eventId}/tickets`,
        method: 'GET',
      }),
      providesTags: ['Tickets'],
    }),
    
    createTicket: builder.mutation<Ticket, Partial<Ticket>>({
      query: (ticket) => ({
        url: '/tickets',
        method: 'POST',
        data: ticket,
      }),
      invalidatesTags: ['Tickets'],
    }),
    
    updateTicket: builder.mutation<Ticket, { id: string; data: Partial<Ticket> }>({
      query: ({ id, data }) => ({
        url: `/tickets/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Tickets'],
    }),
    
    // Payment
    createPaymentIntent: builder.mutation<PaymentIntent, { documentId: string; amount: number; currency: string }>({
      query: (data) => ({
        url: '/payments/intent',
        method: 'POST',
        data,
      }),
    }),
    
    confirmPayment: builder.mutation<void, { payment_intent_id: string; payment_method: string }>({
      query: (data) => ({
        url: '/payments/confirm',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Bookings'],
    }),
  }),
});

export const {
  useGetBookingsQuery,
  useLazyGetBookingsQuery,
  useGetBookingQuery,
  useCreateBookingMutation,
  useUpdateBookingMutation,
  useCancelBookingMutation,
  useCheckInBookingMutation,
  useGetEventTicketsQuery,
  useCreateTicketMutation,
  useUpdateTicketMutation,
  useCreatePaymentIntentMutation,
  useConfirmPaymentMutation,
} = bookingsAPI;
